import { useQuery } from "@tanstack/react-query";

import { useAuth } from "@/providers";
import { useDomainServices } from "@/providers/DomainServices";
import { AllTopicKeysRecord } from "@/shared/domain/topics/TopicRecord.ts";

export default function useAllTopicKeys(
  orgId?: string,
  opts?: { enabled?: boolean },
) {
  const { currentOrganization } = useAuth();
  const canonicalOrgId = orgId || currentOrganization?.org_id;
  const { topics: topicService } = useDomainServices();

  return useQuery<AllTopicKeysRecord, Error>({
    queryKey: ["orgTopicKeys", canonicalOrgId],
    queryFn: ({ signal }) => {
      if (canonicalOrgId === undefined) {
        return Promise.reject(new Error("Invalid orgId"));
      }

      return topicService.getAllTopicKeysForOrg({
        abortSignal: signal,
        resourceOwnerId: canonicalOrgId,
      });
    },
    enabled: canonicalOrgId !== undefined && (opts?.enabled ?? true),
    staleTime: 30000,
  });
}
